<template>
    <div class="flux-fondos-step">
      <div class="flux-fondos-step__msg" v-show="fund.comments !== ''">
        {{ $t("guest.funds.ownerComments", {x: list.ownerName }) }}
      </div>
      <div class="flux-fondos-step__comment" v-show="fund.comments !== ''">
        <div class="b-card-comment">
          {{ fund.comments }}
        </div>
      </div>
      <div class="flux-fondos-pay">
        <h5 class="flux-fondos-pay__title">{{ $t("guest.funds.selectMethod") }}</h5>
        <ul class="flux-fondos-pay__items">
          <li
            class="flux-fondos-pay__item"
            v-for="(paymentType, index) in list.contributionMethods"
            :key="index"
          >
            <input
              type="radio"
              name="paymentMethod"
              :id="'fund_' + fund.id + '_pay-' + paymentType.method.slug"
              :key="'input_fund_' + fund.id + '_pay-' + paymentType.method.slug"
              :value="paymentType.method.id"
              v-model="paymentMethod"
            />
            <label>
              <!-- <img
                :src="$paymentMethods[paymentType.fundPaymentTypeId].icon"
                alt="Método de pago"
              /> -->
              {{ $t("generic." + paymentType.method.slug) }}
            </label>
          </li>
        </ul>
      </div>
      <div class="flux-fondos-step__actions">
        <button
          class="button button--primary button--block"
          @click="next"
          :disabled="paymentMethod === null"
        >
          {{ $t("generic.next") }}
        </button>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "FluxFondosClassicStep1",
    props: {
      fund: {
        type: Object,
        required: true,
      },
      list: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        paymentMethod: null,
      };
    },
    methods: {
      next() {
        this.$emit("next", this.paymentMethod);
      },
    },
    mounted() {
      if (this.list.contributionMethods.length === 1) {
        this.paymentMethod = this.list.contributionMethods[0].method.id;
      }
    }
  };
  </script>
